import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { AccountAssessment } from '../../../models/AssessmentModel';
import { AssessmentService } from '../../../services/assessment.service';
import { SessionService } from '../../../services/session.service';

@Component({
  selector: 'app-riskmap',
  templateUrl: './riskmap.component.html'
})
export class RiskmapComponent implements OnInit {

  get assessment(): AccountAssessment { return this._assessment; }

  @Input()
  set assessment(assessment: AccountAssessment) {
    this._assessment = assessment;
    if (this._assessment) {
      this.updateLineChartData();
    }
  }

  @Input()
  set selectedNistFunction(selectedNistFunction: string) {
    this._selectedNistFunction = selectedNistFunction;
    this.updateLineChartData();
  }

  // x - probability
  // y - impact
  constructor(public _assessmentService: AssessmentService, public _sessionService: SessionService) {
    this.showDark = _sessionService.hasFeature('DASHBOARD_ENABLED');
  }
  _assessment: AccountAssessment;
  _selectedNistFunction: string;
  selectedNistSubCategory: any;
  selectedDataSetIndex: number;
  _mult = 1;
  showDark = false;

  @Output() nistSubCategorySelector: EventEmitter<any> = new EventEmitter();

  @ViewChild('baseChart') chart: BaseChartDirective;

  public lineChartData: Array<any> = [];
  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    chartArea: {
    //   backgroundSolidColor:
      backgroundGradientPoints: [
        { position: 0.0, color: 'rgba(91, 186, 71, 1)' },
        { position: 0.3, color: 'rgba(155, 178, 0, 1)' },
        { position: 0.5, color: 'rgba(216, 164, 10, 1)' },
        { position: 0.7, color: 'rgba(212, 103, 0, 1)' },
        { position: 1.0, color: 'rgba(229, 58, 53, 1)' },
      ]
    },
    scales: {
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Probability'
        },
        gridLines: {
          display: false,
          drawTicks: false
        },
        ticks: {
          min: -5,
          max: 105,
          display: false
        }
      }],
      yAxes: [{
        scaleLabel: {
          display: true,
          labelString: 'Impact'
        },
        gridLines: {
          display: false,
          drawTicks: false
        },
        ticks: {
          min: 0-(1000000 * .1 * this._mult),
          max: 1000000 * 1.1 * this._mult,
          display: false
        }
      }]
    },
    tooltips: {
      displayColors: false,
      callbacks: {
        title (tooltipItem, data) {
          return data.datasets[tooltipItem[0].datasetIndex].label;
        },
        label (tooltipItem, data) {
          return ['Risk: ' + data.datasets[tooltipItem.datasetIndex].riskLabel];
        }
      }
    }
  };
  public lineChartColors: Array<any> = [];
  public lineChartLegend = false;
  public lineChartType = 'scatter';

  public updateLineChartData() {
    const newLineChartData = [];
    if (this._assessment.scoredResultsJson.hasOwnProperty('mult')) {
      this._mult = this._assessment.scoredResultsJson.mult;
    }
    Object.keys(this._assessment.scoredResultsJson.nistFunctions).forEach(nistFunctionKey => {
      if (this._selectedNistFunction == undefined || this._selectedNistFunction == nistFunctionKey) {
        const nistFunction = this._assessment.scoredResultsJson.nistFunctions[nistFunctionKey];
        Object.keys(nistFunction.nistCategories).forEach(nistCategoryKey => {
          const nistCategory = nistFunction.nistCategories[nistCategoryKey];
          Object.keys(nistCategory.nistSubCategories).forEach(nistSubCategoryKey => {
            const nistSubCategory = nistCategory.nistSubCategories[nistSubCategoryKey];
            const rgbColor = 'rgba(196, 196, 196, .8)';
            newLineChartData.push({
              nistFunction: nistFunctionKey,
              nistCategory: nistCategoryKey,
              nistSubCategory: nistSubCategoryKey,
              label: nistSubCategory.text,
              riskLabel: this._assessmentService.getRiskLabel(nistSubCategory),
              data: [{
                x: nistSubCategory.exposureFactor * 100,
                y: nistSubCategory.impact
              }],
              pointBackgroundColor: rgbColor,
              pointBorderColor: `rgba(0, 0, 0, 0.5)`,
              pointHoverBackgroundColor: rgbColor,
              pointHoverBorderColor: `rgba(0, 0, 0, 0.5)`,
              pointRadius: 6,
              pointHoverRadius: 8
            });
          });
        });
      }
    });
    this.lineChartData = newLineChartData;
    this.lineChartOptions.scales.yAxes[0].ticks.min = 0 - (1000000 * .1 * this._mult),
    this.lineChartOptions.scales.yAxes[0].ticks.max = 1000000 * 1.1 * this._mult;

    if (this.chart !== undefined) {
      this.chart.ngOnDestroy();
      this.chart.datasets = this.lineChartData;
      this.chart.chart = this.chart.getChartBuilder(this.chart.ctx);
    }
  }

  ngOnInit() {
  }

  // events
  public chartClicked(e: any): void {
    if (e.active.length > 0 && this.selectedDataSetIndex != e.active[0]._datasetIndex) {
      this.selectedDataSetIndex = e.active[0]._datasetIndex;
      const nistFunction = this.lineChartData[this.selectedDataSetIndex].nistFunction;
      this.selectedNistSubCategory = this.lineChartData[this.selectedDataSetIndex].nistSubCategory;
      this.nistSubCategorySelector.emit({ selectedNistFunction: nistFunction, selectedNistSubCategory: this.selectedNistSubCategory });
    } else {
      this.selectedDataSetIndex = undefined;
      this.nistSubCategorySelector.emit({ selectedNistFunction: undefined, selectedNistSubCategory: undefined });
    }
  }

  public chartHovered(e: any): void { }

}
